module.exports = __webpack_public_path__ + "img/corneille.da662852.jpg";